import { defineMessages, MessageDescriptor } from 'react-intl';

/**
 * Shared audiogram messages for admin (template/style config) and fragments (view/preview).
 * Use with $t() or formatMessage so the extractor picks up ids and defaultMessages.
 */
export const audiogramMessages: Record<string, MessageDescriptor> = defineMessages({
  formatsToGenerate: {
    id: 'admin.fragments.audiogram.formatsToGenerate',
    defaultMessage: 'Formatos a generar',
  },
  formatSquare: {
    id: 'admin.fragments.audiogram.formatSquare',
    defaultMessage: '1:1 (cuadrado)',
  },
  formatHorizontal: {
    id: 'admin.fragments.audiogram.formatHorizontal',
    defaultMessage: '16:9 (horizontal)',
  },
  formatVertical: {
    id: 'admin.fragments.audiogram.formatVertical',
    defaultMessage: '9:16 (vertical)',
  },
  titleColor: {
    id: 'admin.fragments.audiogram.titleColor',
    defaultMessage: 'Color del título',
  },
  captionsColor: {
    id: 'admin.fragments.audiogram.captionsColor',
    defaultMessage: 'Color de los subtítulos',
  },
  visualizerColor: {
    id: 'admin.fragments.audiogram.visualizerColor',
    defaultMessage: 'Color del visualizador',
  },
  backgroundType: {
    id: 'admin.fragments.audiogram.backgroundType',
    defaultMessage: 'Tipo de fondo',
  },
  solidColor: {
    id: 'admin.fragments.audiogram.solidColor',
    defaultMessage: 'Color sólido',
  },
  backgroundColor: {
    id: 'admin.fragments.audiogram.backgroundColor',
    defaultMessage: 'Color del fondo',
  },
  backgroundImage: {
    id: 'admin.fragments.audiogram.backgroundImage',
    defaultMessage: 'Imagen de fondo',
  },
  image: {
    id: 'admin.fragments.audiogram.image',
    defaultMessage: 'Imagen',
  },
  imageUploadSuccess: {
    id: 'admin.fragments.audiogram.imageUploadSuccess',
    defaultMessage: 'Imagen cargada correctamente',
  },
});
